import {ControllerBase} from "../../../controllerBase";

declare var window: any

 export const EditarTipoEntregaOrcamentoController = ControllerBase.extend({
    name: "EditarTipoEntregaOrcamentoController",

    framework: "knockout",

    ajax: function() {
        $("input").on('focus', function () { $(this).select(); });
        return {
            url: "/Orcamento/_EditarTipoEntrega",
            type: "post",
            cache: false
        };
    },

    aposBinding: function () {
        for (var item in this.model.__ko_mapping__.mappedProperties) {
            this.model[item].subscribe(function () {
                window.orcamentoController.model.DadosAlteradosEntrega["editartipoentrega"] = true;
            });
        }
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },


    aplicar: function() {

        var model = this.toJS(this.model);
        var self = this;

        global.ajax({
            url: "/Orcamento/DefinirTipoEntregaCargaItemOrcamento",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                tipoEntrega: model
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                self.model.OpcaoEntrega(data.OpcaoEntrega);
                self.model.Carga(data.Carga);

                if (!data.HasErrors) {
                    global.showSuccessMessage("Tipo de entrega alterado com sucesso");
                    window.orcamentoController.model.DadosAlteradosEntrega["editartipoentrega"] = false;
                    if (self.finalizarCallback) {
                        self.finalizarCallback();
                    }
                }


            }
        });

    }
});

window.EditarTipoEntregaOrcamentoController = EditarTipoEntregaOrcamentoController
